import api from './api';
import { _get, _getAxios, _getAxiosWithoutInterceptor, setAxiosHeader } from "./serviceMain";

export async function getPharmaList() :Promise<any[]> {

    //const url = '/v3/stores/all?appFiltered=true';

    // const data = await api.get(url);
    // return (data?.data ? data.data : []);

    const urlAxios = '/v3/stores/all';
    const queryParams = new URLSearchParams({
      appFiltered: true,
    } as any);


    const data = await _getAxios(urlAxios, "GET_PHARMA_LIST_TIME", "pharmaList",queryParams);
    return data;
  };


export async function getPharmaListNationalIdNumber(nationalIdNumber: string) :Promise<any[]> {

    const queryParams = new URLSearchParams({
      appFiltered: true,
      nationalIdNumber: nationalIdNumber
    } as any);

    const url = '/v3/stores/allForCustomer';
    const data = await _getAxiosWithoutInterceptor(url, "GET_PHARMA_TAXCODE_LIST_TIME", "pharmaTaxCodeList", queryParams);

    return data;
  };

